module.exports = __webpack_public_path__ + "img/smiling-face.e5311e8e.png";